<template>
  <v-app>
    <v-container>
      <v-layout>
        <v-btn color="primary" v-if="showAddButton" @click="addData">{{getAddButtonTitle}}</v-btn>
        <v-btn color="primary" v-if="showSimpleAddButton" @click="addSimpleData">簡易新增</v-btn>
        <v-btn color="primary" v-if="showSimpleAddButton" :loading="simpleImportLoading" @click="addSimpleFile">簡易匯入</v-btn>
        <v-btn color="success" v-if="showExportButton" @click="exportData">匯出</v-btn>

        <input type="file" id="simpleFile" ref="simpleFile" style="display: none;" @change="simpleImportEvent($event.target.files)" accept=".xlsx, .xls">

        <v-select
                v-if="showPaymentStatus"
                :items="getPaymentStatusList"
                item-text="value"
                item-value="key"
                v-model="paymentStatus"
                @change="changePaymentStatus()"
        ></v-select>
        <!-- <v-btn class="primary" dark text v-if="isAdmin && isFinanceCreditList" @click="uploadEvent" depressed>細項回覆匯入</v-btn> -->
        <v-btn class="primary" dark text v-if="isAdmin && isShowImport" @click="importFileEvent" depressed>匯入</v-btn>
        <input type="file" id="uploadEvent" ref="upload" @change="importEvent($event.target.files)" accept=".xlsx, .xls">
      </v-layout>
      <v-layout  mt-2 v-if="showSearchDate">
        <v-flex xs5 sm5 md5>
            <date-picker :date.sync="search.startDate" />
          </v-flex>
          <v-flex xs5 sm5 md5>
            <date-picker :date.sync="search.endDate" />
          </v-flex>
      </v-layout>
      <v-layout mt-2 v-if="showSearchBar">
        <v-flex md2 xs8 v-if="sourceName === 'FinanceCreditList' ||
          !!sourceName
        ">
          <v-select :items="getSearchKeys"
                        item-text="value"
                        item-value="key"
                        v-model="search.searchKey"
                        label="查詢條件"
          ></v-select>
        </v-flex>
        <v-flex ml-2 md5 xs8>
          <v-text-field v-model="search.keyword" :label="`搜尋客戶`" :placeholder="search.placeholder"
          @keyup.enter="searchEvent"></v-text-field>
        </v-flex>
        <v-flex md4 xs4>
          <v-btn color="success" @click="searchEvent">搜尋</v-btn>
          <v-btn color="warning" @click="reset">重置</v-btn>
          <v-btn
            v-if="sourceName === 'FinanceCreditList'"
            color="accent"
            @click="editDialog.visible = true"
          >編輯欄位</v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        v-model="selected"
        :headers="getHeaders"
        :items="items"
        :pagination.sync="pagination"
        :rows-per-page-items="[5,25,50,100,-1]"
        :total-items="totalItems"
        :select-all="showSelect"
        @update:pagination="changePage"
        class="elevation-1"
        :loading="loading"
      >
        <template v-slot:headers="props">
          <tr>
            <th v-if="showSelect" class="column">
              <v-checkbox
                v-model="selectedAll"
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll(props)"
              ></v-checkbox>
            </th>
            <th
              v-for="(header, i) in props.headers.filter(h=>!h.hidden)"
              :key="i"
              :class="['text-md-center column sortable', pagination.descending ? 'desc'
                            : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              width="20"
              :style="{ minWidth: 0, padding:0}"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props" :active="props.selected">
          <tr :style="getBackgroundColor(props)">
            <td class="text-xs-center" v-if="showSelect">
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
                @click.stop="selectItem(props)"
              ></v-checkbox>
            </td>
            <td
              class="text-md-center"
              style="padding:0 5px;"
              v-for="col in getHeaders.filter(h=>!h.hidden)"
              :key="col.value"
            >
              <v-btn class="red" dark v-if="col.value === 'delete'" @click="remove(props)">刪除</v-btn>
              <v-btn
                  class="primary"
                  style="min-width: 0;"
                  v-if="col.value === 'tools'"
                  @click="edit(props)"
                >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                style="min-width: 0;"
                v-else-if="col.value === 'uploadEvent'"
                @click="edit(props)"
              >{{ props.item.fileURL === null ? '上傳':'檢視'}}</v-btn>
              <v-btn
                class="primary"
                v-if="col.value === 'edit'"
                @click="edit(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="success"
                v-else-if="col.value === 'question'"
                :disabled="props.item.displayId === ''"
                @click="questionView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="success"
                v-else-if="col.value === 'notify'"
                :disabled="props.item.displayId === '' || props.item.notifyTip === false"
                @click="notify(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="success"
                v-else-if="col.value === 'priority'"
                :disabled="props.item.displayId === '' || props.item.caseStatus !== 3"
                @click="priorityView(props)"
              >{{col.text}}</v-btn>
<!--              <v-btn-->
<!--                class="success"-->
<!--                v-else-if="col.value === 'questionStatus'"-->
<!--                @click="changeQuestionStatus(props)">已回覆</v-btn>-->
              <v-btn
                class="primary"
                v-else-if="col.value === 'print'"
                @click="printView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'invoiceDocument'"
                :disabled="!props.item.fileURL1"
                @click="invoiceView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'settingDocument'"
                :disabled="!props.item.fileURL2"
                @click="settingDocumentView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'requestPaymentURL'"
                :disabled="!props.item.requestPaymentURL"
                @click="requestPaymentView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'page'"
                @click="pageView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'upload'"
                @click="uploadView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'uploadFile'"
                @click="uploadFileView(props)"
              >{{col.text}}</v-btn>
              <v-btn
                class="primary"
                v-else-if="col.value === 'changeCase'"
                @click="changeCaseView(props)"
              >{{col.text}}</v-btn>
              <span
                v-else-if="col.value ==='birthday' || col.value ==='startDate'
                            || col.value ==='endDate' || col.value ==='approvedDate'"
              >
                {{ props.item[col.value].year }}-
                {{ props.item[col.value].month }}-
                {{ props.item[col.value].day }}
              </span>
              <span v-else-if="col.value ==='city'">{{ props.item.city }}{{ props.item.area }}</span>
              <span v-else-if="col.value ==='agent'">{{ props.item[col.value].displayName }}</span>
              <span
                v-else-if="col.value ==='parentAgentName'"
              >{{ props.item.parentAgent.displayName }}</span>
              <span v-else-if="col.value ==='authority'">{{ getAuthority(props.item) }}</span>

              <!--原融-->
              <span v-else-if="col.value ==='questionData'">{{ props.item.question }}</span>

              <span v-else-if="col.value ==='applyDate'">
                {{ props.item[col.value].year }}-
                {{ props.item[col.value].month }}-
                {{ props.item[col.value].day }}
              </span>

              <span v-else-if="col.value ==='name'">{{ props.item.name }}</span>
              <span v-else-if="col.value ==='enable'" :style="props.item.enable === false ? 'color:red;':''">{{ props.item.enable === true ? '啟用':'停用' }}</span>
              <span v-else-if="col.value ==='latePaymentCount'" :style="props.item.latePaymentCount > 0 ? 'color:red;':''">{{ getLatePayment(props.item) }}</span>
              <span v-else-if="col.value ==='memberId'">{{ props.item.memberId }}</span>
              <span v-else-if="col.value ==='productName'">{{ getCaseProduct(props.item) }}</span>
              <span v-else-if="col.value ==='productId'">{{ getCaseProduct(props.item) }}</span>
              <span v-else-if="col.value ==='contactTime'">{{ getContactTimeInfo(props.item) }}</span>
              <span v-else-if="col.value ==='parentAgentId'">{{ findAgent(props.item[col.value]) }}</span>
              <span v-else-if="col.value ==='creditPrice'">{{ props.item.totalPrice }}</span>
              <span
                v-else-if="col.value ==='installmentsNumber'"
              >{{ props.item.installmentsNumber }}</span>
              <span v-else-if="col.value ==='creditPriceMonth'">{{ props.item.creditPriceMonth }}</span>
              <span v-else-if="col.value ==='totalCreditPrice'">{{ props.item.totalCreditPrice }}</span>
              <!--原融 END-->

              <span v-else-if="col.value ==='agentPhone'">{{ props.item.parentAgent.cellphone }}</span>
              <span
                v-else-if="col.value ==='confirmAgentPhone'"
              >{{ props.item.confirmAgent.cellphone }}</span>
              <span v-else-if="col.value ==='store'">{{ props.item[col.value].name }}</span>
              <v-select
                v-else-if="col.options"
                :items="col.options"
                item-text="value"
                item-value="key"
                v-model="props.item[col.value]" @change="changeOption(props)"></v-select>
              <span
                v-else-if="col.value ==='status'"
                :class="props.item[col.value] === 0 ? 'text-danger':'blue--text'"
              >{{ props.item[col.value] === 0 ? '未請款':'已請款' }}</span>
              <div v-else-if="col.value === 'caseStatus' &&  (isAdmin || isStaff || isInsureAgent)">
                <v-select v-if="col.isEdit === true && !isInsureAgent"
                  :items="getCaseStatusList"
                  item-text="value"
                  item-value="key"
                  v-model="props.item[col.value]"
                  @change="changeStatus(props)"
                ></v-select>
                <span v-else>{{ getCaseStatus(props.item)}}</span>
              </div>
              <div v-else-if="col.value === 'caseStatus' && col.isEdit === true && !isAdmin && !isStaff">
                <span v-if="props.item[col.value] === 7 || props.item[col.value] === 8">{{ getCaseStatus(props.item)}}</span>
                <v-select v-else
                  :items="getCaseStatusList"
                  item-text="value"
                  item-value="key"
                  v-model="props.item[col.value]"
                  @change="changeStatus(props)"
                ></v-select>
              </div>
              <span v-else-if="col.value === 'caseStatus' && col.isEdit === false">{{ getCaseStatus(props.item)}}</span>
              <v-select
                v-else-if="col.value === 'priorityStatus'"
                :items="getPriorityStatusList"
                item-text="value"
                item-value="key"
                v-model="props.item['status']"
                @change="changePriorityStatus(props)"
              ></v-select>
              <span v-else-if="col.value ==='category'">{{ getCategory(props.item) }}</span>
              <span v-else-if="col.value ==='caseType'">{{ getCaseType(props.item) }}</span>
              <span v-else-if="col.value ==='type' ">{{ getTradeType(props.item.type) }}</span>
              <span v-else-if="col.value ==='tradeStatus'">{{ getTradeStatus(props.item.tradeStatus) }}</span>
              <span v-else-if="col.value ==='sealSelf'">{{ getSealSelf(props.item.sealSelf) }}</span>
              <span v-else>{{ props.item[col.value] }}</span>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <v-btn color="primary" @click="loadData">重新整理</v-btn>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog
      v-model="editDialog.visible"
      :max-width="isMobile ? '90%':'50%'"
    >
    <v-card>
      <v-card-title class="headline">
          {{editDialog.title}}
      </v-card-title>
      <v-card-text>
      <v-data-table :headers="dialogTableHeader" :items="getDialogColumns" class="elevation-1">
        <template v-slot:items="props">
          <td>{{ props.item.text }}</td>
          <td>
            <v-checkbox v-model="props.item.isShow"
              ></v-checkbox>
          </td>
        </template>
      </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" @click="removeTableColumns">恢復預設</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="editDialog.visible = false">取消</v-btn>
        <v-btn color="primary" text @click="saveTableColumns">確定</v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import XLSX, { utils } from 'xlsx';
import MobileDetect from "mobile-detect";
import { mapGetters } from "vuex";
import DatePicker from "../components/DatePicker";
import NoticeManager from "../utils/notice_manager";
import common from '@/mixins/common';
const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "ListEditor",
  props: [
    "columnKeys",
    "items",
    "loading",
    "showSearchBar",
    'showSimpleAddButton',
    "showAddButton",
    "showExportButton",
    "showSearchDate",
    "totalItems",
    "searchPlaceHolder",
    "startDate",
    "endDate",
    "sourceName",
    "isFinanceCreditList",
    "isShowImport",
    "getSearchKeys",
    'showSelect',
    'showPaymentStatus',
    'simpleImportLoading'
  ],
  components: {
    DatePicker
  },
  data() {
    return {
      selected:[],
      selectedAll: false,
      pagination: {
        sortBy: "createDate",
        descending: "desc",
        page: 1,
        length: 5
      },
      editedItem: null,
      search: {
        keyword: "",
        placeholder: this.searchPlaceHolder
          ? this.searchPlaceHolder
          : "搜尋身分證、名稱",
        searchDate: [],
        startDate: this.startDate,
        endDate: this.endDate,
        searchKey:'',
      },
      editDialog: {
        title: "編輯欄位",
        visible: false
      },
      dialogTableHeader: [
        {
          text: "欄位",
          align: "left",
          sortable: false,
          value: "text"
        },
        {
          text: "是否顯示",
          sortable: false,
          value: "isShow"
        }
      ],
      headerColumns: [],
      isImportFile: false,
      paymentStatus: 7
    };
  },
  mixins:[common],
  computed: {
    ...mapGetters(["getUserInfo"]),
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    getDialogColumns() {
      if (this.sourceName === "FinanceCreditList") {
        return this.headerColumns.filter(m => m.isEdit);
      } else {
        return [];
      }
    },
    getHeaders() {
      let columns = this.headerColumns;
      if (this.sourceName === "FinanceCreditList") {
        columns = columns.filter(m => m.isShow);
      }
      return columns;
    },
    getCaseTypeList() {
      return [
        { key: "0", value: "機車原融" },
        { key: "1", value: "借新還舊" },
        { key: "2", value: "他行代償" }
      ];
    },
    getAddButtonTitle(){
      return this.sourceName === "CaList" ? "裕富-機車N申請書" : "新增"
    }
  },
  created() {
    const localColumns = localStorage.getItem("headerColumns");
    const hasLocalObject = this.sourceName === "FinanceCreditList" && localColumns;
    this.headerColumns = hasLocalObject
      ? JSON.parse(localColumns)
      : JSON.parse(JSON.stringify(this.columnKeys));

    NoticeManager.addObserver('resetSelectItem',()=>{
      this.selected = [];
      this.selectedAll = false;
    });
  },
  watch:{
    "search.startDate"(value) {
      this.changeSearchData(value)
    },
    "search.endDate"(value) {
      this.changeSearchData(value)
    },
  },
  methods: {
    findAgent(agentId){
      const find = this.getAgentList.find(agent=>agent.agentId === agentId);
      if (find){
        return find.displayName
      }
      return agentId;
    },
      getBackgroundColor(props){
        // console.log(`getBackgroundColor == ${JSON.stringify(props.item)}`);
        if (props.item.examResult === true){
          return { backgroundColor: '#ffffa3'};
        }

        if (props.item.notifyTip === true){
          return { backgroundColor: '#ffe099'};
        }

        if (props.index % 2 === 0){
          return { backgroundColor: '#ededed'};
        }
        return {};
      },
      toggleAll(props){
        this.selectedAll = !this.selectedAll;

        if (this.selected.length) this.selected = []
        else this.selected = this.items.slice()

        console.log(`selectItem ${JSON.stringify(this.selected)}`);
        this.$emit('selectData', this.selected);
      },
      selectItem(props){
        props.selected = !props.selected;

        console.log(`selectItem ${JSON.stringify(this.selected)}`);
        this.$emit('selectData', this.selected);
      },
      uploadEvent () {
        this.isImportFile = false;
        const uploadbtn = this.$refs.upload;
        uploadbtn.click();
      },
      importFileEvent(){
        this.isImportFile = true;
        const uploadbtn = this.$refs.upload;
        uploadbtn.click();
      },
      async importEvent(files){
        const workBook = await this.readerWorkBookFromLocal(files[0]);
        const workSheet = workBook.Sheets[workBook.SheetNames[0]]
        const content = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]]);
        this.$refs.upload.value = null;
        this.checkingExcelData(content);
      },
      async simpleImportEvent(files){
        const workBook = await this.readerWorkBookFromLocal(files[0]);
        const content = XLSX.utils.sheet_to_json(workBook.Sheets[workBook.SheetNames[0]]);
        this.$refs.simpleFile.value = null;
        console.log(`simpleImportData = ${JSON.stringify(
          content
        )}`)
        this.$emit('simpleImportData', content);
      },
      readerWorkBookFromLocal(file) {
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        return new Promise(function (resolve, reject) {
            reader.onload = function (e) {
                const fileData = e.target.result;
                if (reader.readyState === 2) {
                    const workBook = XLSX.read(fileData, { type: 'binary' });
                    resolve(workBook);
                } else {
                    reject('讀取文件失敗');
                }
            }
        })
      },
      async checkingExcelData(dataList){
        console.log(`dataList = ${JSON.stringify(
          dataList
        )}`)

        if (this.isImportFile){
          this.$emit('importData', dataList);
        } else {
          this.saveLoading = true;
          var excelData = [];

          for (let i = 0;i < dataList.length;i++) {
            const file = dataList[i];
            const fileLength = Object.keys(file).length;
            if(fileLength > 1 && i != 0)
            {
              const data = {};
              data.displayId = file["__EMPTY_1"];
              data.result = file["__EMPTY_3"];
              excelData.push(data);
            }
          }
          this.$emit('importData', excelData);
        }

      },
    getAuthority(item) {
      if (item.authority === "admin") {
        return this.$t("admin");
      }
      if (item.authority === "agent") {
        return this.$t("agent");
      }
      if (item.authority === "sales") {
        return this.$t("sales");
      }
      return this.$t("store");
    },
    changePage(page) {
      console.log(`page ${JSON.stringify(page)}`);
      this.$emit("changePage", page);
    },
    getCategory(item) {
      if (item.category === 0) {
        return "機車原融申請書";
      } else if (item.category === 1) {
        return "購物分期申請書";
      } else if (item.category === 2) {
        return "商品貸分期申請書";
      }
      return "機車原融申請書";
    },
    getLatePayment(item) {
        if (item.latePaymentCount === -1){
          return '無繳款單'
        } else if (item.latePaymentCount === 0){
          return '繳款正常'
        } else if (item.latePaymentCount > 0){
          return '逾期'
        }
        return '無繳款單'
    },
    getCaseProduct(item) {
      if (item.category === 2 && (item.productId === '0' || !item.productId)) {
        return '機車N專案';
      }
      if (item.productId === '0') {
        return '機車原融';
      }
      if (item.productId === '1') {
        return '借新還舊';
      }
      if (item.productId === '2') {
        return '他行代償';
      }
      return '機車原融';
    },
    getCaseType(item) {
      //3超優 0優加 1優質 2一般
      if (item.category === 2 && item.caseType === 3){
        return "超優";
      }
      if (item.category === 0 || item.category === 1 ||
          item.category === 2 ||
          item.category === 3) {
        const list = [
          { key: 3, value: "超優" },
          { key: 0, value: "優加" },
          { key: 1, value: "優質" },
          { key: 2, value: "一般" },
        ];
        return list.find(i => i.key === item.caseType).value;
      }
      return "優質";
    },
    getSealSelf(status) {
      const list = this.sealSelfList;
      const find = list.find(i => i.key === status || i.key === `${status}`);
      if (find){
        return find.value;
      }
      return 0;
    },
    getTradeStatus(status) {
      const list = this.tradeStatusList;
      const find = list.find(i => i.key === status || i.key === `${status}`);
      if (find){
        return find.value;
      }
      return 0;
    },
    getTradeType(type) {
      console.log(`getTradeType == ${type}`);
      const list = this.tradeTypeList;
      const find = list.find(i => i.key === type || i.key === `${type}`);
      console.log(`getTradeType == ${JSON.stringify(find)}`);
      if (find){
        return find.value;
      }
      return 0;
    },
    getCaseStatus(item) {
      // 0進件中 1婉拒 2待捕
      const list = this.getCaseStatusList;
      if (!item.caseStatus) {
        return list[0].value;
      }
      return list.find(i => i.key === item.caseStatus).value;
    },
    getPriorityStatus(item) {
      // 0待處理 1已處理
      const list = this.getPriorityStatusList;
      if (!item.caseStatus) {
        return list[0].value;
      }
      return list.find(i => i.key === item.caseStatus).value;
    },
    getContactTimeInfo(item) {
      const list = this.getContactTimeList;
      return list.find(i => i.key === item.contactTime).text;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    loadData() {
      this.$emit("handleLoadData");
    },
    addData() {
      this.$emit("addData");
    },
    addSimpleData(){
      this.$emit("addSimpleData");
    },
    addSimpleFile(){
      const uploadbtn = this.$refs.simpleFile;
      uploadbtn.click();
    },
    save() {
      this.$emit("saveData");
    },
    edit(props) {
      this.editedItem = props.item;
      this.$emit("editData", this.editedItem);
    },
    remove(props) {
      this.editedItem = props.item;
      this.$emit("removeData", this.editedItem);
    },
    printView(props) {
      this.editedItem = props.item;
      this.$emit("printData", this.editedItem);
    },
    invoiceView(props) {
      this.editedItem = props.item;
      console.log(JSON.stringify(props));
      this.$emit("openDocument", this.editedItem.fileURL1);
    },
    settingDocumentView(props) {
      this.editedItem = props.item;
      console.log(JSON.stringify(props));
      this.$emit("openDocument", this.editedItem.fileURL2);
    },
    requestPaymentView(props) {
      this.editedItem = props.item;
      console.log(JSON.stringify(props));
      this.$emit("openDocument", this.editedItem.requestPaymentURL);
    },
    questionView(props) {
      this.editedItem = props.item;
      this.$emit("questionData", this.editedItem);
    },
    notify(props) {
      this.editedItem = props.item;
      this.$emit("notify", this.editedItem);
    },
    priorityView(props) {
      console.log(JSON.stringify(this.editedItem));
      this.editedItem = props.item;
      this.$emit("priorityData", this.editedItem);
    },
    pageView(props) {
      this.editedItem = props.item;
      this.$emit("pageView", this.editedItem);
    },
    changeCaseView(props) {
      this.editedItem = props.item;
      this.$emit("changeCaseView", this.editedItem);
    },
    uploadView(props) {
      this.editedItem = props.item;
      this.$emit("uploadData", this.editedItem);
    },
    uploadFileView(props) {
      this.editedItem = props.item;
      this.$emit("uploadFileData", this.editedItem);
    },
    changeStatus(props) {
      this.editedItem = props.item;
      this.$emit("changeStatus", this.editedItem);
    },
    changePaymentStatus() {
      this.$emit("changePaymentStatus", this.paymentStatus);
    },
    changePriorityStatus(props) {
      this.editedItem = props.item;
      this.$emit("changePriorityStatus", this.editedItem);
    },
    changeOption(props){
      this.editedItem = props.item;
      this.$emit("changeOption", this.editedItem);
    },
    searchEvent() {
      console.log(`listEditor searchEvent`)
      if (this.showSearchDate) {
        this.$emit("searchData", this.search);
      } else {
        this.$emit("searchData", this.search.keyword);
      }
    },
    changeSearchData (value) {
      if(/^\d{4}\-\d{2}\-\d{2}$/.test(value) && !this.showSearchBar && value) {
        this.$emit("searchData", this.search);
      }
    },
    reset() {
      this.search.keyword = "";
      this.search.searchDate = [];
      this.search.searchKey = '';
      this.setDefualtDate();
      if (this.showSearchDate) {
        this.$emit("searchData", this.search);
      } else {
        this.$emit("searchData", this.search.keyword);
      }
    },
    saveTableColumns() {
      localStorage.setItem("headerColumns", JSON.stringify(this.headerColumns));
      this.editDialog.visible = false;
    },
    removeTableColumns() {
      localStorage.removeItem("headerColumns");
      this.headerColumns = JSON.parse(JSON.stringify(this.columnKeys));
      this.editDialog.visible = false;
    },
    exportData() {
      this.$emit("exportData");
    },
    dateChange(val) {
      // this.searchInfo.birthday = val.split(' - ');
    },
    changeQuestionStatus(props) {
      this.editedItem = props.item;
      this.$emit("changeQuestionStatus", this.editedItem);
    },
    setDefualtDate(){
        let date = new Date();
        //将当前月份加1，下移到下一个月
        date.setMonth(date.getMonth() + 1);
        //将当前的日期置为0，
        date.setDate(0);
        //再获取天数即取上个月的最后一天的天数
        let days = date.getDate();
        let currentDate = new Date().toISOString().substr(0, 10);
        const [year, month, day] = currentDate.split("-");
        this.search.startDate = `${year}-${month}-01`;
        this.search.endDate = `${year}-${month}-${days}`;
    },
  }
};
</script>

<style scoped>
#uploadEvent{
  height: 0;
  width: 0;
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/ListEditor.vue